// extracted by mini-css-extract-plugin
module.exports = {"box":"FlippingSquare_box__1VRaZ","plane":"FlippingSquare_plane__3MBRr","flip":"FlippingSquare_flip__3XRjb"};